// // Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyDqov1SpGtGvJELrxwNmkuebXOmIQAgP0I",
//   authDomain: "ask-questions-2d083.firebaseapp.com",
//   projectId: "ask-questions-2d083",
//   storageBucket: "ask-questions-2d083.appspot.com",
//   messagingSenderId: "93005213504",
//   appId: "1:93005213504:web:ad410739192b05a2dd54a5",
//   measurementId: "G-VW9XWRK47Y",
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";

const app = firebase.initializeApp({
  apiKey: "AIzaSyDqov1SpGtGvJELrxwNmkuebXOmIQAgP0I",
  authDomain: "ask-questions-2d083.firebaseapp.com",
  projectId: "ask-questions-2d083",
  storageBucket: "ask-questions-2d083.appspot.com",
  messagingSenderId: "93005213504",
  appId: "1:93005213504:web:ad410739192b05a2dd54a5",
  measurementId: "G-VW9XWRK47Y",
});

export const auth = app.auth();
export const projectStorage = firebase.storage();
export default app;
